<div class="form">
  <div id="gridConfigValidationDiv" class="grid-container">
    <!--Testata configurazione colonne-->
    <dx-data-grid
      id="gridConfigFilters"
      [dataSource]="gridConf.preFilters"
      [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true"
      [showBorders]="false"
      [showColumnLines]="true"
      [showRowLines]="true"
      (onRowUpdated)="onConfigRowUpdating($event)"
      [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
      (onToolbarPreparing)="hideButtons($event)"
      (onEditingStart)="saveData()"
    >
      <dxi-column
        dataField="widget"
        [caption]="'Widget' | siaTranslate"
        [width]="150"
      >
        <dxo-lookup
          [dataSource]="gridWidgets"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
      </dxi-column>

      <dxi-column
        dataField="field"
        [caption]="'Nome Campo' | siaTranslate"
        [width]="150"
      >
        <dxo-lookup [dataSource]="tempCols"></dxo-lookup>
      </dxi-column>

      <dxi-column
        dataField="operator"
        [caption]="'Operatore' | siaTranslate"
        [width]="130"
      >
        <dxo-lookup
          [dataSource]="gridConfFiltersTypes"
          displayExpr="name"
          valueExpr="id"
        >
        </dxo-lookup>
      </dxi-column>

      <dxi-column dataField="pattern" [caption]="'Pattern' | siaTranslate">
        <dxo-lookup
          [dataSource]="gridConfPatternsTypes"
          displayExpr="name"
          valueExpr="id"
        >
        </dxo-lookup>
      </dxi-column>

      <dxi-column dataField="staticValue" [caption]="'Valore' | siaTranslate">
      </dxi-column>

      <dxi-column
        dataField="countFilter"
        [caption]="'Per conteggio' | siaTranslate"
        dataType="boolean"
      >
      </dxi-column>

      <dxo-editing
        mode="batch"
        refreshMode="repaint"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
        [selectTextOnEditStart]="selectTextOnEditStart"
        [startEditAction]="startEditAction"
      >
      </dxo-editing>

      <dxo-selection mode="single"></dxo-selection>
      <dxo-remote-operations [sorting]="true" [paging]="true">
      </dxo-remote-operations>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
      <dxo-load-panel [enabled]="false"></dxo-load-panel>
      <dxo-header-filter [visible]="false"></dxo-header-filter>
      <dxo-filter-row [visible]="false"></dxo-filter-row>
      <dxo-search-panel [visible]="false"></dxo-search-panel>
      <dxo-group-panel [visible]="false"></dxo-group-panel>
      <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    </dx-data-grid>
  </div>
</div>
